<template>
    <div class="main-view" :class="{ main: isHome, topic: !isHome }">
        <div class="top-section">
            <!--            <transition name="slide-up">-->
            <div class="home-header" ref="homeHeader" :style="{ 'margin-top': headerTop + 'px' }">
                <h1>Bądź eko!</h1>
                <p>Wybierz jeden z poniższych tematów, aby sprawdzić, jak być eko na co dzień!</p>
            </div>
            <!--            </transition>-->
            <div class="topic-selector-section">
                <div class="topic-selector-wrapper">
                    <div class="topic-selector-container">
                        <TopicSelector />
                    </div>
                </div>
                <transition name="fade">
                    <div class="curve-container">
                        <svg
                            class="curve"
                            version="1.1"
                            viewBox="0 0 100.22 42.114"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0"
                                y="42"
                                width="100.23"
                                height="2"
                                fill="#ffffff"
                                stroke="#ffffff"
                            ></rect>
                            <g transform="translate(-11.879 -47.735)">
                                <path
                                    d="m112.1 47.776s-7.5408-1.2568-9.803 10.054c-2.2622 11.311-12.257 20.264-12.257 20.264s-9.7544 11.074-27.785 10.882c-18.03 0.1918-28.314-10.882-28.314-10.882s-9.9949-8.953-12.257-20.264c-2.2622-11.311-9.803-10.054-9.803-10.054v42.072h100.19l0.0333-42.072"
                                    class="white"
                                    :class="{ green: !isHome }"
                                />
                            </g>
                        </svg>
                        <div class="curve-fix" :class="{ green: !isHome }"></div>
                    </div>
                </transition>
            </div>
        </div>

        <div class="bottom-section">
            <transition name="fade">
                <div class="topic-container" v-if="!isHome">
                    <transition name="fade-content" mode="out-in">
                        <TopicContent :topic="activeTopic" :key="activeTopicName" />
                    </transition>
                </div>
            </transition>
        </div>

        <transition name="fade">
            <div class="return-button" v-if="!isHome" @click="goHome">
                <img src="../assets/icons/arrow-return.svg" alt="return" />
            </div>
        </transition>
    </div>
</template>

<script>
    // Component
    import TopicSelector from '@/components/TopicSelector';
    import TopicContent from '@/components/TopicContent';
    // Model
    import { topicsData } from '@/model/topics-data';

    export default {
        name: 'Main',
        components: { TopicContent, TopicSelector },
        data: function () {
            return {
                isHome: true,
                activeTopicName: undefined,
                headerTop: 0,
            };
        },
        beforeMount() {
            const currentRoute = this.$router.currentRoute;
            if (currentRoute.name === 'main') {
                this.isHome = true;
                this.activeTopicName = undefined;
            } else {
                this.isHome = false;
                this.activeTopicName = currentRoute.params.topic;
            }
        },
        watch: {
            $route(to) {
                if (to.name === 'main') {
                    this.isHome = true;
                    this.activeTopicName = undefined;
                } else {
                    this.isHome = false;
                    this.activeTopicName = to.params.topic;
                    this.slideUpHeader();
                }
            },
            isHome: function (val) {
                if (val) {
                    this.slideDownHeader();
                } else {
                    this.slideUpHeader();
                }
            },
        },
        computed: {
            activeTopic: function () {
                if (this.isHome) {
                    return {};
                } else {
                    for (let topicObj of topicsData) {
                        if (topicObj.name === this.activeTopicName) {
                            return topicObj;
                        }
                    }
                    return topicsData[0];
                }
            },
        },
        methods: {
            goHome: function () {
                this.$router.push({ name: 'main', params: {} });
            },
            slideUpHeader: function () {
                this.headerTop = -this.$refs.homeHeader.clientHeight;
            },
            slideDownHeader: function () {
                this.headerTop = 0;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .main-view {
        @media (min-height: 668px) {
            .home-header {
                padding-top: 11vh !important;
                padding-bottom: 6vh !important;
            }
        }
        .home-header {
            padding-left: 60px;
            padding-right: 60px;
            padding-top: 60px;
            margin-left: auto;
            margin-right: auto;
            color: $white;
            transition: margin-top 0.4s, opacity 0.4s;

            h1 {
                margin-top: 0;
                margin-bottom: 8px;
                font-size: 33px;
            }

            p {
                margin-top: 0;
            }
        }

        &.topic .home-header {
            opacity: 0;
        }

        .top-section {
            background-color: $dark-green;

            .topic-selector-section {
                position: relative;
                width: 100%;
                height: 0;
                padding-top: 84%;
            }

            .topic-selector-wrapper {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
            }

            .topic-selector-container {
                padding-top: 8%;
                display: flex;
                justify-content: center;
            }

            .curve-container {
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 0;
                pointer-events: none;
                touch-action: none;
            }

            .curve {
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 0;
                z-index: 1;

                .white {
                    transition: fill 0.4s;
                    fill: $white;
                }

                .green {
                    fill: $green;
                }
            }

            .curve-fix {
                position: absolute;
                z-index: 10;
                background-color: $white;
                width: 100%;
                height: 6px;
                left: 0;
                bottom: -3px;
                transition: background-color 0.4s;

                &.green {
                    background-color: $green;
                }
            }
        }

        .bottom-section {
            .topic-container {
                background-color: $green;
            }
        }

        .return-button {
            position: fixed;
            left: 30px;
            top: 30px;
            z-index: 800;

            img {
                width: 35px;
            }
        }

        &.main {
            min-height: 100vh;

            @media screen and (max-width: 374px) {
                padding-bottom: 50px;
            }
            @media screen and (min-width: 430px) {
                padding-bottom: 100px;
            }
        }
    }

    .fade-content-enter-active,
    .fade-content-leave-active {
        transition: opacity 0.6s;
    }

    .fade-content-enter,
    .fade-content-leave-to {
        opacity: 0;
    }
</style>
